import { render, staticRenderFns } from "./keywordSearch.vue?vue&type=template&id=38564d4a&scoped=true&"
import script from "./keywordSearch.vue?vue&type=script&lang=js&"
export * from "./keywordSearch.vue?vue&type=script&lang=js&"
import style0 from "./keywordSearch.vue?vue&type=style&index=0&id=38564d4a&lang=scss&scoped=true&"
import style1 from "./keywordSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38564d4a",
  null
  
)

export default component.exports